import { createReducer, createNamespacer } from '../../commons/js/utils/reducer';

const bollist = createNamespacer("BOL_SCREEN")

const initialState = {
    list: {
        bol: {},
        isLoading: false,
        isPrintLoading: false,
        error: "",
        showGenerateBol: false,
        showEmailPopup: false,
        status: "",
        url: "",
        fileName: '',
        pdfGenerated: false,
        clearInterval: 0,
    },
}

export const bolReducer = createReducer(initialState.list, {
    [bollist("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [bollist("SET_PRINT_LOADING")]: (state, action) => {
        return {
            ...state,
            isPrintLoading: action.payload.value,
        }
    },
    [bollist("SET_BOL")]: (state, action) => {
        return {
            ...state,
            bol: action.payload.value,
        }
    },
    [bollist("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    "SET_BOL_PDF_URL": (state, action) => {
        return {
            ...state,
            url: action.payload.value,
        }
    },
    [bollist("SET_CLEAR_INTERVAL")]: (state, action) => {
        return {
            ...state,
            clearInterval: action.payload.clearInterval,
        }
    },
    [bollist("SET_PDF_STATUS")]: (state, action) => {
        return {
            ...state,
            status: action.payload.value,
        }
    },
    [bollist("SET_STATUS")]: (state, action) => {
        return {
            ...state,
            status: action.payload.value,
            url: action.payload.url,
            fileName: action.payload.fileName,
        }
    },
    "SET_GENERATE_BOL": (state, action) => {
        return {
            ...state,
            showGenerateBol: action.payload.value,
        }
    },
    "SET_BOL_EMAIL": (state, action) => {
        return {
            ...state,
            showEmailPopup: action.payload.value,
        }
    },

})